/**
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * 
 * @todo - this whole file need to be rewrited as we do with i.e InteractiveMap.
 * For now Im leaving this as it is because for now it works as expected so we
 * don't want to extend current sprint loop because of this rewrite.
 * 
 * In api.js we already have prepared special classes & methods to get map config.
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * 
 */

const $ = require('jquery')

const { URL_API, BREAKPOINT } = require('@/modules/api')
const customScrollbar = require('@/modules/customScrollbar')
const { globals, getJson, getCenterCoords, loadCustomMapStyles, getMarker, mapMarkerIcon, setDefaultMapPosition, updateMapProperties } = require('@/modules/globals')

/**
  * @TODO: przenieść tutaj globalne eventy jak toggle dropdownów dla każdej mapy
  *
 **/
const CustomMapEvents = {
  toggleSelect () {
    if ($(this).next().hasClass('hidden')) {
      $('.pageMap').find('.dropdown-menu').addClass('hidden')
      $(this).next().removeClass('hidden')
    } else {
      $(this).next().addClass('hidden')
    }
  },
  hideSelect () {
    return $(this).parent('.dropdown-menu').addClass('hidden')
  },
}

const refreshMapOnResize = function() {
  return google.maps.event.trigger(globals.googleMapsMapReference, 'resize')
}

const salespointsMap = {
  // Private members
  $salesPointsFoundNumber: null,
  $salesPointsFoundOfficesList: null,
  $salesPointsAuthorizedOfficesList: null,
  $salesPointsSelectedOfficeOfficesList: null,
  $salesPointsPartnerOfficesList: null,

  /**
     * Filters rules in format:
     * - each field define dropdown
     * - each value of field define value that must match
     */
  filterRules: {},

  /**
     * Return representation of dropdown entry as string ready to paste into DOM
     * Parameters as order is:
     * - type: radio group name and 'filterRules' field name if selected
     * - key: will be 'filterRules' field value if selected
     * - val: displayed as label of that entry (same 'key' by default)
     */
  dropdownRenderer (type, id, key, val) {
    if (val === undefined) val = key

    return (
      `${'<div class="list-element">' +
            '<input id="officeSelector__id--'}${type}${id 
      }"  name="officeSelector__id--${type}" type="radio" value="${key}" hidden>` +
            `<label for="officeSelector__id--${type}${id}">${val}</label>` +
            '</div>'
    )
  },

  /**
     * Invoked once at startup setting up dropdowns and handler
     */
  setupAllDropdowns (json, mapMarkers) {
    const $salesPoints = $('.salesPoints');
    [
      { type: 'region', list: [ [ '', 'Wszystkie województwa' ] ].concat(json.Voivodeships) },
      { type: 'city', list: [ [ '', 'Wszystkie miasta' ] ].concat(json.Cities) },
      {
        type: 'type', list: [ [ '', 'Wszystkie biura' ], [ 'partner', 'Partnerskie biura' ], [ 'franczyza', 'Autoryzowane biura' ] ],
      } ].forEach(function(t) {
      salespointsMap.renderSpecDropdownList(
        t.type,
        $salesPoints.find(`.officeSelector__${t.type} .officeSelector__box__form-group`),
        t.list)
    })

    $('.officeSelector__box span').on('click', CustomMapEvents.toggleSelect)
    $('.officeSelector__box__form-group').on('change', CustomMapEvents.hideSelect)

    const geocoder = new google.maps.Geocoder()

    const zoomer = function(address, zoomLevel) {
      geocoder.geocode({ 'address': address || 'Polska' }, function(res, status) {
        if (status === 'OK') {
          globals.googleMapsMapReference.setCenter(res[0].geometry.location)
          globals.googleMapsMapReference.setZoom(zoomLevel || 6)
        }
      })
      salespointsMap.salesPointsViewerData.reset()
    }

    const filterMarkers = function(type) {
      const markers = mapMarkers.filter(function(marker) {
        const icon = marker.icon
        marker.setVisible(true)

        if (icon.indexOf(type) === -1) {
          return marker
        } else {
          return null
        }
      })

      return markers.forEach(function(marker) {
        marker.setVisible(false)
      })
    }

    $('.officeSelector__region').on('change', function(e) {
      $('.officeSelector__city input').removeAttr('checked')
      $('.officeSelector__city').find('.select-title').text('Wybierz miasto')

      if (e.target.value) {
        zoomer(e.target.value, 8)
      } else {
        zoomer()
      }
    })

    $('.officeSelector__city').on('change', function(e) {
      const region = $('[name=officeSelector__id--region]:checked').filter(function() { return this.value !== '' })

      if (e.target.value) {
        zoomer(e.target.value, 12)
      } else if (region.length) {
        zoomer(region.get(0).value, 8)
      } else {
        zoomer()
      }
    })

    $('.officeSelector__type').on('change', function(e) {
      const $selectedOption = $(e.currentTarget).find('input:checked')

      filterMarkers($selectedOption.val())
    })

    $salesPoints.find('.officeSelector__box__form-group').on('change', function(e) {
      const input = $(e.target)
      const parent = input.closest('.officeSelector__box')
      const labelText = input.siblings('label').text()

      const rule = parent.get(0).dataset.officeselector__type
      if (rule == 'region') {
        salespointsMap.filterRules['city'] = undefined
      }
      salespointsMap.filterRules[rule] = input.attr('value')

      customScrollbar.rebuildScroll($('.salesPoints__list'))
      salespointsMap.updateSalesPointListItem(json, rule, labelText)

      /**
             *  Need to set active class to input parent after each change because cities
             *  are re-rendered and it loses informations about last selected option
            **/
      $(this).find('.list-element input').prop('checked', false)
      parent.attr('data-last-selected', input.val())

      $('.officeSelector__box').find('input').each(function() {
        if ($(this).val() === $(this).closest('.officeSelector__box').attr('data-last-selected')) {
          $(this).prop('checked', true)
        }
      })
      return parent.find('.select-title').text(labelText)
    })
  },

  /**
     * Setting up dropdown by adding entries into them
     * Parameters are:
     * - type: 'filterRules' field name
     * - element: dropdown DOM element
     * - list: entry list to add
     */
  renderSpecDropdownList (type, element, list) {
    if (element && list) list.forEach(function(value, index) {
      if (typeof value === 'object' && value.length === 2)
        element.append(salespointsMap.dropdownRenderer(type, index, value[0], value[1]))
      else
        element.append(salespointsMap.dropdownRenderer(type, index, value, value))
    })
  },

  /**
     * Return representation of entry in list aside of map as string ready to paste into DOM
     */
  salesPointRenderer (office) {
    return (
      `<div class="salesPoints__list__item salesPoints__list__item--${office.OfficeType} col-lg-4 col-sm-3" ` +
            `data-lat="${office.Latitude}" data-lng="${office.Longitude}">` +
            `<div class="point-item ${office.OfficeType}">` +
            `<div class="city">${office.City}</div>` +
            `<strong>${office.Name}</strong>` +
            `<div class="street">ul. ${office.Street}</div>` +
            `<div class="tel">tel. ${office.Phone}</div>` +
            '</div>' +
            '</div>'
    )
  },

  salesPointsViewerData: {
    prevCenter: null,
    prevZoom: null,
    last: null,

    reset () {
      this.prevCenter = null
      this.prevZoom = null
      this.last = null
    },
  },

  setupSalesPointsViewer (containerSelector, actionAreaClass, offices, settings) {
    const _ = this

    $(containerSelector).on('click', function(e) {
      const elem = e.target.closest(actionAreaClass)
      const $selectedOffice = $(elem).closest('.salesPoints__selectedOffice')
      const obj = {
        Latitude: elem.dataset.lat,
        Longitude: elem.dataset.lng,
        Zoom: 14,
      }

      function setView (location) {
        globals.googleMapsMapReference.setCenter({ lat: parseFloat(location.lat), lng: parseFloat(location.lng) })
        globals.googleMapsMapReference.setZoom(14)
      }

      function handleEventsForScreenResolution (dataset) {
        if (window.innerWidth < BREAKPOINT.TABLET) {
          _.openMapOnMobileClick(obj)
        } else {
          setView(dataset)
        }
      }

      if (elem) {
        if ($selectedOffice.length && window.innerWidth > BREAKPOINT.TABLET) {
          salespointsMap.$salesPointsSelectedOffice.hide()
          salespointsMap.$salesPointsAuthorized.show()
          salespointsMap.$salesPointsPartner.show()

          $(actionAreaClass).removeClass('active')
          setDefaultMapPosition(settings)
          return false
        }

        if (salespointsMap.salesPointsViewerData.prevCenter === null) {
          salespointsMap.salesPointsViewerData.prevCenter = globals.googleMapsMapReference.getCenter()
          salespointsMap.salesPointsViewerData.prevZoom = globals.googleMapsMapReference.getZoom()

          handleEventsForScreenResolution(elem.dataset)

          salespointsMap.salesPointsViewerData.last = elem

          if (window.innerWidth < BREAKPOINT.TABLET) {
            salespointsMap.markerOfficeInformation.addInformation(elem.dataset, offices)
          }

          $(actionAreaClass).removeClass('active')
          $(elem).addClass('active')
        } else if (salespointsMap.salesPointsViewerData.last === elem) {
          globals.googleMapsMapReference.setCenter(salespointsMap.salesPointsViewerData.prevCenter)
          globals.googleMapsMapReference.setZoom(salespointsMap.salesPointsViewerData.prevZoom)

          salespointsMap.salesPointsViewerData.reset()
          $(actionAreaClass).removeClass('active')
        } else {
          handleEventsForScreenResolution(elem.dataset)
          salespointsMap.salesPointsViewerData.last = elem

          if (window.innerWidth < BREAKPOINT.TABLET) {
            salespointsMap.markerOfficeInformation.addInformation(elem.dataset, offices)
          }

          $(actionAreaClass).removeClass('active')
          $(elem).addClass('active')
        }
      }

      return null
    })
  },

  updateCitiesDropdownList (voivodeship, cities) {
    const group = $('.officeSelector__city .officeSelector__box__form-group')
    group.text('')

    salespointsMap.renderSpecDropdownList('city', group,
      [ undefined, '' ].indexOf(voivodeship) !== -1 ?
        [ [ '', 'Wszystkie miasta' ] ].concat(cities)
        : [ [ '', 'Wszystkie miasta' ] ].concat(salespointsMap.tupleVoivodeshipCities[voivodeship])
    )
  },

  /**
     * List that pair filters rules with field in json.Offices single element.
     * Format for each element of this list:
     * - first element define dropdown filter (e.g. 'region')
     * - second element define name of field in object for lookup for compare values (e.g. 'Voivodeship')
     * - third element if true show FindView if exist rule in 'filterRules' that match first element
     */
  dropdownList: [ [ 'region', 'Voivodeship', true ], [ 'city', 'City', true ], [ 'type', 'OfficeType' ] ],

  updateSalesPointListItem (json) {
    let offices = json.Offices
    let enableFindView = false

    salespointsMap.dropdownList.forEach(function(t) {
      if ([ undefined, '' ].indexOf(salespointsMap.filterRules[t[0]]) === -1 && t[2])
        enableFindView = true
    })
    salespointsMap.$salesPointsAuthorized.hide()
    salespointsMap.$salesPointsPartner.hide()
    salespointsMap.$salesPointsFound.hide()
    salespointsMap.$salesPointsSelectedOffice.hide()

    salespointsMap.$salesPointsFoundOfficesList.html('')

    salespointsMap.updateCitiesDropdownList(salespointsMap.filterRules['region'], json.Cities)

    if (enableFindView) {
      salespointsMap.dropdownList.forEach(function(t) {
        if ([ undefined, '' ].indexOf(salespointsMap.filterRules[t[0]]) === -1)
          offices = offices.filter(function(office) {
            return salespointsMap.filterRules[t[0]] === office[t[1]]
          })
      })

      if ([ undefined, '' ].indexOf(salespointsMap.filterRules['type']) !== -1)
        offices = offices.filter(function(office) {
          return [ 'wlasne', '' ].indexOf(office.OfficeType) === -1
        })

      offices.sort(function(a, b) { return a.Name.localeCompare(b.Name) })

      offices.forEach(function(t) {
        salespointsMap.$salesPointsFoundOfficesList.append(salespointsMap.salesPointRenderer(t))
      })

      const number = offices.length
      if (number > 0) {
        salespointsMap.$salesPointsFoundNumber.html(`Znaleziono ${number} ${
          number === 1 ? 'biuro' : (Math.floor(number / 10) % 10 !== 1
                        && [ 2, 3, 4 ].indexOf(number % 10) !== -1 ? 'biura' : 'biur')}`
        )
      } else
        salespointsMap.$salesPointsFoundNumber.html('Nie znaleziono biur')

      salespointsMap.$salesPointsFound.show()
    }
    else if ([ undefined, '' ].indexOf(salespointsMap.filterRules['type']) !== -1) {
      salespointsMap.$salesPointsAuthorized.show()
      salespointsMap.$salesPointsPartner.show()
    }
    else if (salespointsMap.filterRules['type'] === 'partner') {
      salespointsMap.$salesPointsPartner.show()
    }
    else if (salespointsMap.filterRules['type'] === 'franczyza') {
      salespointsMap.$salesPointsAuthorized.show()
    }
  },

  renderSalesPointListItem (json) {
    salespointsMap.$salesPointsAuthorizedOfficesList.html('')
    salespointsMap.$salesPointsPartnerOfficesList.html('')
    salespointsMap.$salesPointsFound.hide()

    json.Offices.forEach(function(office) {
      // Const officesList;
      if (office.OfficeType === 'partner')
        salespointsMap.$salesPointsPartnerOfficesList.append(salespointsMap.salesPointRenderer(office))
      else if (office.OfficeType === 'franczyza')
        salespointsMap.$salesPointsAuthorizedOfficesList.append(salespointsMap.salesPointRenderer(office))
    })
  },

  openMapOnMobileClick (settings) {
    const salesPoints = $('.salesPoints')
    const salesPointsMapWrapper = $('.salesPoints__mapWrapper')[0]
    const officeSelector = $('.officeSelector')[0]
    const salesPointsMobileMap = $('.salesPoints__mobile-map__map')
    const salesPointsMobilePapFilter = $('.salesPoints__mobile-map__filter')
    const center = getCenterCoords(settings)

    salesPoints.addClass('salesPoints--mobile--shown')
    $('body').addClass('salesPoints--show-map')
    salesPoints[0].addEventListener('animationend', function() {
      refreshMapOnResize()

      globals.googleMapsMapReference.setCenter(center)
      globals.googleMapsMapReference.setZoom(parseInt(settings.Zoom))
      google.maps.event.addListener(globals.googleMapsMapReference, 'tilesloaded', function() {
        refreshMapOnResize()
      })

      $('body').css('overflow', 'hidden')
    })
    salesPointsMobileMap.append(salesPointsMapWrapper)
    salesPointsMobilePapFilter.prepend(officeSelector)
  },

  closeMapOnMobileClick (json) {
    const salesPoints = $('.salesPoints')
    const salesPointsMapWrapper = $('.salesPoints__mapWrapper')[0]
    const officeSelector = $('.officeSelector')[0]
    const salesPointsBody = $('.salesPoints--body')
    const salesPointsDropdown = $('.salesPoints__dropdown')

    salespointsMap.markerOfficeInformation.removeInformation()
    salespointsMap.renderSalesPointListItem(json)

    salespointsMap.$salesPointsAuthorized.show()
    salespointsMap.$salesPointsPartner.show()

    salesPoints.removeClass('salesPoints--mobile--shown')
    $('body').removeClass('salesPoints--show-map')

    salesPointsBody.prepend(salesPointsMapWrapper)
    salesPointsDropdown.prepend(officeSelector)

    refreshMapOnResize()
    $('body').css('overflow', 'auto')
  },

  toggleMapMobileFilters () {
    const salesPointsMobileMap = $('.salesPoints__mobile-map__map')

    salespointsMap.markerOfficeInformation.removeInformation()
    salesPointsMobileMap.toggleClass('salesPoints__mobile-map__map--filterview')
  },

  clearMapMobileFilters (settings, markers) {
    salespointsMap.toggleMapMobileFilters()
    setDefaultMapPosition(settings)

    markers.forEach(function(marker) {
      marker.setVisible(true)
    })
  },

  runMapForMobile (json, mapMarkers) {
    const salesPoints = $('.salesPoints')

    const openMap = this.openMapOnMobileClick.bind(this, json.Settings)
    const clearFilters = this.clearMapMobileFilters.bind(undefined, json.Settings, mapMarkers)
    const closeMap = this.closeMapOnMobileClick.bind(undefined, json)

    salesPoints.find('.salesPoints__mobile-view-switcher').on('click', openMap)
    salesPoints.find('.salesPoints__normal-view-switcher').on('click', closeMap)
    salesPoints.find('.salesPoints__mobile-map__filter-toggle, .salesPoints__mobile-map__filter__toggle').on('click', this.toggleMapMobileFilters)
    salesPoints.find('.salesPoints__mobile-map__filter__clear').on('click', clearFilters)

    const toggleMobileView = function() {
      if (BREAKPOINT.TABLET >= window.innerWidth) {
        salesPoints.addClass('salesPoints--mobile')
      } else {
        salesPoints.removeClass('salesPoints--mobile')
      }
    }

    $(window).resize(refreshMapOnResize)
    $(window).resize(toggleMobileView)
    toggleMobileView()
  },

  markerOfficeInformation: {
    $officeInfo: $('.salesPoints__mobile-map__office'),
    addInformation (office, officesList, marker) {
      const officeData = officesList == null ? office : officesList.filter(function(item) {
        if (item.Latitude === office.lat && item.Longitude === office.lng) {
          return item
        } else {
          return null
        }
      })[0]

      salespointsMap.$salesPointsAuthorized.hide()
      salespointsMap.$salesPointsPartner.hide()
      salespointsMap.$salesPointsFound.hide()

      salespointsMap.$salesPointsSelectedOfficeOfficesList.html('')

      if (window.innerWidth < BREAKPOINT.TABLET) {
        this.$officeInfo.show()

        this.$officeInfo.empty().append(salespointsMap.salesPointRenderer(officeData))
      } else {
        salespointsMap.$salesPointsSelectedOffice.show()
        salespointsMap.$salesPointsSelectedOfficeOfficesList.append(salespointsMap.salesPointRenderer(officeData))
      }

      // Set map zoom and position after marker click
      if (marker != null) {
        const markerLat = marker.position.lat()
        const markerLng = marker.position.lng()

        updateMapProperties({ Zoom: 14 }, markerLat, markerLng)
      }
    },
    removeInformation () {
      this.$officeInfo.hide()

      return this.$officeInfo.empty()
    },
    officeOnMouseover (office) {
      const $officesList = $('.salesPoints__list__item')

      for (const item in $officesList) {
        const dataset = $officesList[item].dataset

        if (dataset.lat === office.Latitude && dataset.lng === office.Longitude) {
          return $officesList[item].classList.add('active')
        }
      }

      return null
    },
    officeOnMouseout () {
      return $('.salesPoints__list__item').removeClass('active')
    },
  },

  resetMapButton (controlDiv) {
    const controlUI = document.createElement('div')
    controlUI.className = 'resetMap'
    controlUI.style.backgroundColor = '#fff'
    controlUI.style.backgroundImage = 'url("/assets/images/Maps/Salesmap/others/marker_reset.png")'
    controlUI.style.width = '28px'
    controlUI.style.height = '28px'
    controlUI.style.marginTop = '10px'
    controlUI.style.marginLeft = '10px'
    controlUI.style.cursor = 'pointer'
    controlUI.title = ''
    controlDiv.appendChild(controlUI)

    // Set CSS for the control interior.
    const controlText = document.createElement('div')
    controlUI.appendChild(controlText)

    // Required to get initial labels texxt
    const baseFilterLabels = $('.officeSelector__box').map(function() {
      return this.firstElementChild.innerText
    }).toArray()

    function resetMap () {
      $('.officeSelector__box').each(function(i, block) {
        $(block).find('input').first().prop('checked', false)
        $(block).find('input').first().click()
        $(block).find('.select-title').text(baseFilterLabels[i])
      })
    }

    $(controlDiv).on('click', resetMap)
  },

  loadMap () {
    const apiUrl = URL_API.salespointsMap
    const mapMarkers = []
    globals.infowindow = new google.maps.InfoWindow()

    const $salespointList = $('.salesPoints__list')

    salespointsMap.$salesPointsFound = $('.salesPoints__found')
    salespointsMap.$salesPointsAuthorized = $('.salesPoints__authorized')
    salespointsMap.$salesPointsPartner = $('.salesPoints__partner')
    salespointsMap.$salesPointsSelectedOffice = $('.salesPoints__selectedOffice')

    salespointsMap.$salesPointsFoundNumber = salespointsMap.$salesPointsFound.find('.salesPoints__found__number')

    salespointsMap.$salesPointsFoundOfficesList = salespointsMap.$salesPointsFound.find('.officesList')
    salespointsMap.$salesPointsAuthorizedOfficesList = salespointsMap.$salesPointsAuthorized.find('.officesList')
    salespointsMap.$salesPointsPartnerOfficesList = salespointsMap.$salesPointsPartner.find('.officesList')
    salespointsMap.$salesPointsSelectedOfficeOfficesList = salespointsMap.$salesPointsSelectedOffice.find('.officesList')

    getJson(apiUrl).then(function(json) {
      const offices = json.Offices
      const settings = json.Settings

      salespointsMap.tupleVoivodeshipCities = json.Voivodeships.reduce(function(accumul, viv) {
        accumul[viv] = json.Offices.reduce(function(acc, office) {
          if (office.Voivodeship === viv && acc.indexOf(office.City) === -1)
            acc.push(office.City)
          return acc
        }, [])
        return accumul
      }, {})

      salespointsMap.setupSalesPointsViewer('.salesPoints__list', '.salesPoints__list__item', offices, settings)

      globals.googleMapsMapReference = new google.maps.Map(document.querySelector('.salesPoints__mapWrapper'), {
        zoom: parseInt(settings.Zoom),
        center: getCenterCoords(settings),
        styles: loadCustomMapStyles(settings.CustomStyles),
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.LEFT_TOP,
        },
      })

      globals.googleMapsMapReference.addListener('click', function() {
        salespointsMap.markerOfficeInformation.removeInformation()
      })

      offices.forEach(function(office) {
        const position = new google.maps.LatLng(office.Latitude, office.Longitude)
        const marker = getMarker(position, globals.googleMapsMapReference, mapMarkerIcon[office.OfficeType])
        mapMarkers.push(marker)

        marker.addListener('click', function() {
          salespointsMap.markerOfficeInformation.addInformation(office, null, marker)
        })
        marker.addListener('mouseover', function() {
          salespointsMap.markerOfficeInformation.officeOnMouseover(office)
        })
        marker.addListener('mouseout', function() {
          salespointsMap.markerOfficeInformation.officeOnMouseout()
        })
      })

      const markerClusterOptions = {
        zoomOnClick: true,
        gridSize: 20,
        maxZoom: 8,
        styles: [ {
          url: '/assets/images/Maps/Salesmap/others/clusters/cluster1.png',
          height: 26,
          width: 26,
          iconAnchor: [ 12, 12 ],
        } ],
      }

      new MarkerClusterer(globals.googleMapsMapReference, mapMarkers, markerClusterOptions)

      const centerControlDiv = document.createElement('div')
      new salespointsMap.resetMapButton(centerControlDiv, json.Settings)

      centerControlDiv.index = 1
      globals.googleMapsMapReference.controls[google.maps.ControlPosition.TOP_LEFT].push(centerControlDiv)

      salespointsMap.setupAllDropdowns(json, mapMarkers)
      salespointsMap.renderSalesPointListItem(json)
      salespointsMap.runMapForMobile(json, mapMarkers)

      customScrollbar.init($salespointList)
      customScrollbar.update($salespointList)

      globals.googleMapsMapReference.addListener('tilesloaded', function() {
        $('.gm-fullscreen-control').parent().css({
          background: '#fff',
          width: 34,
          height: 34,
          display: window.innerWidth > BREAKPOINT.TABLET ? 'block' : 'none',
        })
      })
    })
  },
}

module.exports = salespointsMap



// WEBPACK FOOTER //
// ./src/components/googleMap/SalespointsMap.js